var _a;
import { __setFunctionName } from "tslib";
import './autoComplete.scss';
/**
 * Component for autocomplete input. E.g.:
 *
 *  <autocomplete items="$ctrl.listIntentions"
 *     ng-model="$ctrl.newTerm"
 *     search-for="name"
 *     custom-search="$ctrl.loadTerms"
 *     show-text="name"
 *     search-length="0"
 *     permissionType="write"
 *     label="My label"
 *  ></autocomplete>
 *
 * @param {string} permissionType - the permission type to be used. Values should be "write" or "read"
 * TODO: add other params
 */
const AutoCompleteComponent = {
    require: {
        ngModel: '?ngModel',
    },
    template: `
    <div class="autocomplete-container">
        <label ng-if="$ctrl.label">{{$ctrl.label}}</label>
        <div angucomplete-alt
            id="{{$ctrl.id}}"
            class="autocomplete-component"
            auto-match="false"
            placeholder="{{$ctrl.placeholder}}"
            maxlength="{{$ctrl.maxLength}}"
            minlength="{{$ctrl.searchLength}}"
            pause="$ctrl.pause"
            input-changed="$ctrl.inputChanged"
            selected-object="$ctrl.itemSelected"
            local-data="$ctrl.items"
            local-search="$ctrl.customSearch"
            search-fields="{{$ctrl.searchFor}}"
            title-field="{{$ctrl.showText}}"
            input-class="form-control form-control-small"
            text-no-results="{{$ctrl.showNotFoundText ? $ctrl.notFoundText : $ctrl.model.name}}"
            text-searching="{{'utils.forms.searching' | translate}}..."
            match-class="highlight"
            focus-in="$ctrl.onFocus()"
            focus-out="$ctrl.onFocusOut()"
            disable-input="$ctrl.isInputDisabled()"
            focus-first="true"
            initial-value="$ctrl.initialValue"
            ></div>
    </div>
    `,
    controllerAs: '$ctrl',
    controller: (_a = class {
            constructor(PermissionsService, $translate, $scope) {
                'ngInject';
                this.PermissionsService = PermissionsService;
                this.$translate = $translate;
                this.inputChanged = (value) => {
                    this.model =
                        typeof value === 'string' && value.trim() !== ''
                            ? { [this.searchFor]: value, [this.showText]: value }
                            : undefined;
                    if (this.onInputChanged) {
                        this.onInputChanged({ $value: value });
                    }
                };
                this.itemSelected = ($item) => {
                    if (!$item) {
                        return;
                    }
                    this.model = $item.originalObject;
                    if (this.onSelected) {
                        this.onSelected({ $item: $item.originalObject });
                    }
                };
                this.init();
            }
            async init() {
                this.notFoundText = await this.$translate('utils.errorMsg.57');
                if (this.showNotFoundText === undefined) {
                    this.showNotFoundText = true;
                }
                if (!this.maxLength) {
                    this.maxLength = 300;
                }
                this.hasPermissions = await this.PermissionsService.hasPermissions(this.permissionType);
            }
            isInputDisabled() {
                if (typeof this.disableInput === 'undefined') {
                    return !this.hasPermissions || this.disableInput;
                }
                else {
                    return this.disableInput;
                }
            }
            set model(value) {
                if (this.ngModel) {
                    this.ngModel.$setViewValue(value);
                }
            }
            get model() {
                return this.ngModel ? this.ngModel.$viewValue : undefined;
            }
        },
        __setFunctionName(_a, "controller"),
        _a.$inject = ['PermissionsService', '$translate', '$scope'],
        _a),
    bindings: {
        id: '@',
        items: '<',
        showText: '@',
        searchFor: '@',
        placeholder: '@?',
        pause: '<?',
        onSelected: '&?',
        onFocus: '&?',
        onFocusOut: '&?',
        onInputChanged: '&?',
        customSearch: '<?',
        searchLength: '<?',
        maxLength: '<?',
        itemSelected: '<?',
        showNotFoundText: '<?',
        initialValue: '=?',
        disableInput: '<?',
        permissionType: '<?',
        label: '@?',
    },
};
export default AutoCompleteComponent;
